<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class='bx bx-bar-chart-alt-2 me-1 text-primary'></i>
                                    Performances
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Search performance by label." placement="top" container="body">
                                        <i class="bx bx-search-alt"></i>
                                    </span>
                                    <input type="text" class="form-control border-start-0" id="search"
                                        placeholder="Search..." autocomplete="off" [(ngModel)]="searchKeyword">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertPerformance()"
                                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.performanceedit' : ''">
                                    <i class="bx bx-plus"></i> Add Performance
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Label</th>
                                    <th scope="col" width="150">Value</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let performance of performances | search : 'label' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{performance.label}}</td>
                                    <td>{{performance.value}}</td>
                                    <td class="actions">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" [id]="i" [checked]="performance.disabled"
                                              [ngClass]="{'no-event':performance?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                              [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.performance.edit' :performance.disabled ? 'Mark ' + performance.name + ' as disabled' : 'Mark ' + performance.name + ' as enabled.'"
                                              placement="top" container="body" [(ngModel)]="performance.disabled"
                                              (change)="togglePerformanceStatus(performance)">
                                            <label class="form-check-label" [for]="i"></label>
                                          </div>
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event':performance?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.performance.edit' : 'Update performance'"
                                            (click)="upsertPerformance(performance)"></i>
                                        <i *ngIf="!performance?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed':!privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): setup.performance.delete' : 'Delete performance'"
                                            (click)="deletePerformance(performance,i)"></i>
                                        <div *ngIf="performance?.isDeleteInProgress" performance="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="5">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container *ngIf="performances && performances.length < 1; else noSearchResults">
                                            <td colspan="5">No performances were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="5"
                                                *ngIf="searchKeyword && (performances | search : 'name' : searchKeyword).length == 0">
                                                No performances were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
